import jsPDF from "jspdf";
import "jspdf-autotable";

const generateStudentResultsPDF = (studentResult) => {
  if (!studentResult) return;

  const doc = new jsPDF("portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("ST. MARY'S JUNIOR SEMINARY - VISIGA", pageWidth / 2, 16, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text("STUDENT EXAMINATION RESULTS", pageWidth / 2, 24, {
    align: "center",
  });

  let y = 36;
  doc.setDrawColor(41, 128, 185);
  doc.setLineWidth(0.5);
  doc.line(15, y - 4, pageWidth - 15, y - 4);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("RESULTS SUMMARY", 15, y);
  y += 8;

  const summaryRows = [
    ["Student Name:", studentResult.studentName],
    ["Class:", studentResult.className],
    ["Examination:", studentResult.examinationType],
    ["Combination:", studentResult.combination],
    ["Total Marks:", String(studentResult.totalMarks ?? "0")],
    ["Average:", String(studentResult.average ?? "0.00")],
    ["Position:", studentResult.position || "N/A"],
  ];

  doc.setFontSize(11);
  summaryRows.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.text(label, 20, y);
    doc.setFont("helvetica", "normal");
    doc.text(value || "N/A", 55, y);
    y += 7;
  });

  y += 4;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("SUBJECT RESULTS", 15, y);

  const subjectRows = Array.isArray(studentResult.subjects)
    ? studentResult.subjects.map((subject) => [
        subject.subject || "",
        subject.marks ?? "",
      ])
    : [];

  doc.autoTable({
    startY: y + 4,
    head: [["Subject", "Marks"]],
    body: subjectRows,
    margin: { left: 15, right: 15 },
    theme: "grid",
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: "bold",
    },
    styles: {
      fontSize: 10,
      cellPadding: 2.5,
      halign: "center",
      valign: "middle",
    },
    columnStyles: {
      0: { halign: "left", cellWidth: 110 },
      1: { cellWidth: 50 },
    },
  });

  doc.setFontSize(9);
  doc.setFont("helvetica", "italic");
  doc.text(
    "St. Mary's Junior Seminary Visiga (SIMS) System",
    pageWidth / 2,
    pageHeight - 15,
    { align: "center" }
  );

  const fileName = `Student_Results_${
    studentResult.studentName?.replace(/\s+/g, "_") || "Unknown"
  }.pdf`;

  doc.save(fileName);
};

export default generateStudentResultsPDF;
